require('./bootstrap');

// Import Chart.js
import Chart from 'chart.js/auto';
window.Chart = Chart;
